import { gsap } from "gsap";

export default class Accordions {
    constructor() {
        this.init();
        this.updateAccordionState();
        this.handleResize();
    }

    init() {
        this.accordionItems = gsap.utils.toArray(".accordion-item");
        this.accordionItems.forEach(accordionItem => this.createAnimation(accordionItem));
    }

    createAnimation(accordion) {
        const accordionHeader = accordion.querySelector(".accordion-header");
        const accordionContent = accordion.querySelector(".accordion-content");
        const accordionButton = accordionHeader.querySelector(".accordion-toggle-btn");

        if (!accordionHeader || !accordionContent) {
            console.warn("Accordion structure is incomplete:", accordion);
            return;
        }

        gsap.set(accordionContent, { height: "auto" });
        accordionHeader.animation = gsap.from(accordionContent, {
            height: 0,
            duration: 0.5,
            ease: "power1.inOut",
            reversed: true,
        });

        const triggerElement = accordionButton || accordionHeader;
        triggerElement.addEventListener("click", () =>
            this.toggleAnimation(accordionHeader, accordionButton)
        );
    }

    toggleAnimation(accordionHeader, accordionButton) {
        const isInFooter = accordionHeader.closest(".footer");
        const isLargeScreen = window.innerWidth >= 1200;
        if (isInFooter && isLargeScreen) {
            return;
        }

        const isReversed = accordionHeader.animation.reversed();
        accordionHeader.animation.reversed(!isReversed);

        if (!accordionHeader.animation.reversed()) {
            accordionHeader.classList.add("active");
            if (accordionButton) {
                accordionButton.textContent = "Fermer";
            }
        } else {
            accordionHeader.classList.remove("active");
            if (accordionButton) {
                accordionButton.textContent = "Voir le détail";
            }
        }
    }

    handleResize() {
        window.addEventListener("resize", () => this.updateAccordionState());
    }

    updateAccordionState() {
        const isLargeScreen = window.innerWidth >= 1200;

        this.accordionItems.forEach(accordion => {
            const accordionHeader = accordion.querySelector(".accordion-header");
            const accordionButton = accordionHeader.querySelector(".accordion-toggle-btn");
            const isInFooter = accordion.closest(".footer");

            if (isInFooter && isLargeScreen) {
                accordionHeader.animation.reversed(false);
                accordionHeader.classList.add("active");
                if (accordionButton) {
                    accordionButton.textContent = "Fermer";
                }
                accordionHeader.style.pointerEvents = "none";
            } else {
                accordionHeader.style.pointerEvents = "";
                accordionHeader.classList.remove("active");
                if (accordionButton) {
                    accordionButton.textContent = "Voir le détail";
                }
                accordionHeader.animation.reversed(true);
            }
        });
    }
}
